import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Loader } from '../../../components/common';
import TeamRepPanel from './TeamRepPanel';
/**
 * @param {Array<import('../../../redux').TeamRepDetails>} repList
 * @param {Array<number>} selectedReps
 * @param {boolean} loading
 * @param {(selectedRepId: number) => void} onRepClick
 * @param {() => void} onGlobalRepClick
 * @param {{current: boolean}} draggedRef
 */
const TeamReps = ({ repList, selectedReps, loading, onRepClick, onGlobalRepClick, draggedRef, }) => {
    const handleOnRepClick = (selectedRepId) => {
        const isDragging = draggedRef.current;
        draggedRef.current = false;
        if (!isDragging) {
            onRepClick(selectedRepId);
        }
    };
    const handleOnGlobalRepClick = () => {
        const isDragging = draggedRef.current;
        draggedRef.current = false;
        if (!isDragging) {
            onGlobalRepClick();
        }
    };
    return (_jsxs("div", { children: [_jsxs("div", { className: "flex items-center justify-between h-[41px] rounded-t-lg border-x border-b p-2.5 pt-3", children: [_jsxs("div", { className: "text-sm pl-1.5", children: ["Reps ", _jsx("span", { className: "text-gray-600 text-xs", children: selectedReps.length > 0 ? `${selectedReps.length} selected` : '' })] }), _jsx("div", { className: "text-[0.8rem] pr-1.5", children: _jsx("div", { onClick: handleOnGlobalRepClick, onTouchStart: handleOnGlobalRepClick, className: "text-blue-500 hover:cursor-pointer", children: selectedReps.length === 0 ? 'Select all' : 'Deselect all' }) })] }), _jsx("div", { className: "w-[280px] max-h-[574px] rounded-b-lg overflow-auto", children: loading ?
                    _jsx(Loader, { className: "my-3.5" })
                    :
                        repList && repList.map((rep) => {
                            return (_jsx(TeamRepPanel, { rep: rep, selectedReps: selectedReps, onRepClick: handleOnRepClick }, rep.id));
                        }) })] }));
};
TeamReps.propTypes = {
    repList: PropTypes.array,
    selectedReps: PropTypes.array,
    loading: PropTypes.bool,
    onRepClick: PropTypes.func,
    onGlobalRepClick: PropTypes.func,
    draggedRef: PropTypes.object,
};
export default TeamReps;
